"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styletronReact = require("styletron-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const StyleableButton = props => {
  const {
    className = '',
    disabled = false,
    ...buttonProps
  } = props;
  const [css] = (0, _styletronReact.useStyletron)();
  return /*#__PURE__*/_react.default.createElement("button", _extends({
    type: "button",
    className: `
        ${css({
      background: 'transparent',
      border: 'none',
      transition: 'all .125s ease-in-out',
      padding: 0,
      ':disabled': {
        opacity: 0.33
      },
      ':active': {
        filter: 'contrast(2)'
      },
      ':hover': {
        opacity: disabled ? 0.33 : 0.75
      }
    })}
        ${'align-items-stretch'
    /* Chrome and Safari (webkit?) default to start for buttons */
    }
        ${className}
      `,
    disabled: disabled
  }, buttonProps));
};

var _default = StyleableButton;
exports.default = _default;